import { navBarContext, authContext } from "./context/context";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useContext, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { getFunctions, httpsCallable } from "firebase/functions";
import Logo from "../assets/prairiwhite.png";
import Flag from "../assets/flag.png";
import {
  NewStartup,
  Modal,
  PrairiButton,
  TextButton,
  Loading,
  InvitationPrompt,
  BugTab,
  Viewer,
} from "@peterfosso/prairi-components";
import {
  collection,
  db,
  getDoc,
  doc,
  query,
  where,
  getDocs,
  updateDoc,
  addDoc,
} from "../firebase/firebaseApp";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/firebaseApp";
import axios from "axios";
import { sendBugEmails, useWindowDimensions } from "../utils";

//hi

const SharedMatch = (props) => {
  const { navBarHeight } = useContext(navBarContext);
  let { startupId, investorId } = useParams();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [viewerSrc, setViewerSrc] = useState("");
  let navigate = useNavigate();
  const [dataFetched, setDataFetched] = useState(false);
  const [startupData, setStartupData] = useState({});
  const [investorData, setInvestorData] = useState({});
  const [potentialData, setPotentialData] = useState({});
  const [welcomePopup, setWelcomePopup] = useState(true);
  const [interestedPopUp, setInterestedPopUp] = useState(false);
  const [notInterestedPopUp, setNotInterestedPopUp] = useState(false);
  const [promptPopUp, setPromptPopUp] = useState(false);
  const [feedbackPopUp, setFeedbackPopUp] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [feedbackError, setFeedbackError] = useState("");
  const [screenshotUrl, setScreenshotUrl] = useState(""); //for bug report
  const [bugEmail, setBugEmail] = useState("");
  const [bugText, setBugText] = useState(null);
  const [bugError, setBugError] = useState(null);
  const { width, height } = useWindowDimensions();
  const deviceWidth = parseFloat(width);
  const deviceHeight = parseFloat(height);
  const redirectTo404 = () => {
    navigate("/404");
  };

  const functions = getFunctions();

  const handleUpload = (e) => {
    return new Promise((resolve, reject) => {
      const selectedFile = e.target.files[0];

      const storageRef = ref(storage, `bugs/${selectedFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);

      uploadTask.on(
        "state_changed",
        null, // Manejador de progreso (puedes dejarlo como `null` si no necesitas reportarlo)
        (error) => {
          // Manejador de error
          console.error("Upload failed:", error);
          reject(error);
        },
        async () => {
          // Manejador de éxito
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
          console.log("uploaded correctly");
          setScreenshotUrl(downloadURL);
        }
      );
    });
  };

  const handleBugText = (e) => {
    const value = e.target.value;
    setBugText(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const handleBugEmail = (e) => {
    const value = e.target.value;
    setBugEmail(value);
    if (value !== "") {
      setBugError("");
    }
  };

  const validateFields = () => {
    if (!bugText || bugText.trim() === "") {
      setBugError("Please describe the bug.");
      return false;
    }
    if (!bugEmail || bugEmail.trim() === "") {
      setBugError("We need your email address.");
      return false;
    }
    return true;
  };

  const handleUploadAndSendEmail = async (file) => {
    try {
      if (!validateFields()) return;

      let uploadedUrl = screenshotUrl;
      if (file) {
        uploadedUrl = await handleUpload({ target: { files: [file] } });
      }

      console.log(`screenshotUrl ${uploadedUrl}`);
      sendBugEmails(bugEmail, "", bugText, "Shared Match", uploadedUrl || "");
    } catch (error) {
      console.error("Error uploading file or sending email:", error);
    }
  };

  const fetchData = async (startupId, investorId) => {
    // console.log("inside fetchData" + JSON.stringify(currentUser));
    try {
      // Create a callable function reference to the getUserEmail cloud function
      const getUserDataFunction = httpsCallable(functions, "getUserData");

      // Call the cloud function with the userId (docId from URL params)
      const result = await getUserDataFunction({ userId: startupId });

      // Extract the user data from the response
      // Cloud functions return data in result.data
      const { userData } = result.data;

      // Update the state with the fetched user data
      setStartupData(userData);
      const investorResult = await getUserDataFunction({ userId: investorId });
      const { userData: investorData } = investorResult.data;
      setInvestorData(investorData);

      setDataFetched(true);
    } catch (error) {
      // Handle errors if any of the functions throw an error
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(startupId, investorId);

    //console.log(JSON.stringify(matchesData))
  }, [dataFetched]); //REPLACE WITH FUNCTIONS

  const handleOk = () => {
    setPromptPopUp(true);
  };

  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
  };

  return (
    <div
      id="newMatch__main"
      style={{
        marginTop: navBarHeight,
        marginBottom: navBarHeight,
        width: "100%",
        minWidth: "366px",
      }}
      className=""
    >
      <BugTab
        email={bugEmail}
        setEmail={handleBugEmail}
        setText={handleBugText}
        submit={(file) => handleUploadAndSendEmail(file)}
        error={bugError}
        handleFileChange={handleUpload}
      />
      {!dataFetched && (
        <div className="pt-20">
          <Loading />
        </div>
      )}
      {dataFetched && (
        <div className="flex justify-center">
          {!isMobile && (
            <section
              id="newMatch__container"
              className={`
         flex

        m-auto  rounded-md
        min-w-[380px]
       `}
            >
              <div
                className="w-1/3 px-0.5 bg-rainbowBg overflow-y-auto "
                style={{ maxHeight: deviceHeight * 0.8 }}
              >
                <NewStartup
                  startup={startupData}
                  interested={() => setInterestedPopUp(true)}
                  notInterested={() => setNotInterestedPopUp(true)}
                  archive={() => setInterestedPopUp(true)}
                  shared
                  investor={investorData}
                  isMobile={isMobile}
                />
              </div>
              <div className="w-2/3">
                <Viewer
                  src={startupData.formData.company.deck}
                  h={deviceHeight * 0.8}
                />
              </div>

              {!dataFetched && <Loading />}
            </section>
          )}
          {isMobile && (
            <section
              id="newMatch__container"
              className={`
         flex

        m-auto  rounded-md
        min-w-[380px]
       `}
            >
              <div className=" px-0.5 bg-rainbowBg ">
                <NewStartup
                  startup={startupData}
                  interested={() => setInterestedPopUp(true)}
                  notInterested={() => setNotInterestedPopUp(true)}
                  archive={() => setInterestedPopUp(true)}
                  shared
                  investor={investorData}
                  isMobile={isMobile}
                />
              </div>

              {!dataFetched && <Loading />}
            </section>
          )}
        </div>
      )}
      {dataFetched && (
        <Modal open={welcomePopup} size="md" border="silver">
          <div className="p-5 flex flex-col justify-center  items-center">
            <img src={Logo} className="w-1/6 mb-5"></img>
            <div>
              <p className="mb-2 text-center">
                Hey! Here's the profile of the startup recommended by{" "}
                {investorData.contactName}.
              </p>
              {/* <p>Let them know what you think.</p> */}
            </div>

            <div className="mt-2">
              <PrairiButton
                label="OK"
                border="green"
                bgColor="regular"
                textColor="whiteText"
                click={() => setWelcomePopup(false)}
                size="sm"
                rounded="soft"
              />
            </div>
          </div>
        </Modal>
      )}
      <Modal open={interestedPopUp} border="no-border" size="lg">
        <div className="px-2 flex flex-col justify-center">
          <div className="flex justify-end  text-sm pt-2">
            <TextButton
              color="silver"
              click={() => setInterestedPopUp(false)}
              label="x"
            />
          </div>
          <div className="flex justify-center flex-col items-center">
            <img src={Logo} className="w-1/6 mb-5"></img>
            <div className="text-center text-lg font-bold mb-2">
              Looks like you're into this one
            </div>

            <p className="mb-2 text-center">
              To connect with startups like this (and many more that match your
              interests), create a PRAIRI investor account.<br></br>
            </p>

            <PrairiButton
              label="Let's do it"
              border="thinGreen"
              click={() => navigate("/discover")}
              rounded="soft"
              size="md"
            />
          </div>
        </div>
      </Modal>

      <Modal open={notInterestedPopUp} border="no-border" size="lg">
        <div className="px-2 flex flex-col justify-center">
          <div className="flex justify-end  text-sm pt-2">
            <TextButton
              color="silver"
              click={() => setNotInterestedPopUp(false)}
              label="x"
            />
          </div>
          <div className="flex justify-center flex-col items-center">
            <img src={Logo} className="w-1/6 mb-4"></img>
            <div className="text-center text-lg font-bold mb-2">Not a fit?</div>

            <p className="mb-2 text-center">
              That’s okay — with a PRAIRI account, we’ll only show you startups
              aligned with your interests. No spam, no noise — just the right
              matches.
            </p>

            <PrairiButton
              label="Get better matches"
              border="thinGreen"
              click={() => navigate("/discover")}
              rounded="soft"
              size="lg"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SharedMatch;
